import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
    useNavigate,
} from "react-router-dom";
import DashboardLayout from "./components/dashboard-layout/DashboardLayout";
// import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Profile from "./pages/profile/Profile";
import Register from "./components/auth/register/Register";
import Login from "./components/auth/login/Login";
import ScrollToTop from "./components/common/ScrollToTop";
import MockIndex from "./pages/mocks/Index";
import TestInstruction from "./components/test/test-instruction/ObjectiveTestInstruction";
import TestPanel from "./components/test/test-panel/ObjectiveTestPanel";
import ChangePasswordModal from "./components/auth/change-password/ChangePasswordModal";
import HomeIndex from "./pages/user-interface/home/Index";
import CourseIndex from "./pages/user-interface/courses";
import ContactIndex from "./pages/user-interface/contact/Index";
import CourseOverviewIndex from "./pages/user-interface/course-details/Index";
import TopperIndex from "./pages/user-interface/topper/Index";
import TestSeriesIndex from "./pages/user-interface/test-series/Index";
import BlogsIndex from "./pages/user-interface/blogs/Index";
import PhoneLogin from "./components/auth/phone-login/PhoneLogin";
import EnquirePopup from "./components/enquire-form/EnquirePopup";
import AboutIndex from "./pages/user-interface/about/Index";
import FacultyIndex from "./pages/user-interface/faculty/Index";
import ResultIndex from "./pages/user-interface/result/Index";
import CurrentAffairsIndex from "./pages/user-interface/current-affairs/Index";
import CoursePage from "./pages/user-interface/courses/course-page/CoursePage";
import BlogDetails from "./pages/user-interface/blogs/blog-details/BlogDetails";
import PrivacyPolicy from "./components/policy/PrivacyPolicy";
import TermCondition from "./components/policy/TermsCondition";
import RefundPolicy from "./components/policy/RefundPolicy";
import Selections from "./pages/user-interface/about/selections/Selections";
import DownloadSection from "./pages/user-interface/download/Download";
import RecentVacancies from "./pages/user-interface/recent-vacancies/RecentVacancies";
import StudyMaterial from "./pages/study-material/StudyMaterial";
import Support from "./pages/support/Support";
import CourseDetails from "./pages/user-interface/courses/courses-details/CourseDetails";
import BlogDetailsComponent from "./pages/user-interface/home/blog-preview/blog-details/BlogDetails";
import FreeInitiative from "./pages/user-interface/free-initiative/Index";
import ObjectiveTestInstruction from "./components/test/test-instruction/ObjectiveTestInstruction";
import PrivateRoute from "./utils/PrivateRoute";
import SubjectiveTestInstruction from "./components/test/test-instruction/SubjectiveTestInstruction";
import FullMockTestInstruction from "./components/test/test-instruction/FullMockTestInstruction";
import ObjectiveTestPanel from "./components/test/test-panel/ObjectiveTestPanel";
import SubjectiveTestPanel from "./components/test/test-panel/SubjectiveTestPanel";
import FullMockTestPanel from "./components/test/test-panel/FullMockTestPanel";
import ObjectiveTestReport from "./components/test/test-report/ObjectiveTestReport";
import SubjectiveTestReport from "./components/test/test-report/SubjectiveTestReport";
import FullMockTestReport from "./components/test/test-report/FullMockTestReport";
import UpcomingBatchesDetails from "./pages/user-interface/home/upcoming-batches/upcoming-batches-details/UpcomingBatchesDetails";
import NoFound from "./pages/user-interface/no-found/NoFound";
import RecentVacancyDetails from "./pages/user-interface/recent-vacancies/recent-vacancies-details/RecentVacancyDetails";
import CurrentAffairDetails from "./pages/user-interface/current-affairs/current-affairs-details/CurrentAffairDetails";

// language
import "./i18n";
import { useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AnswerWriting from "./pages/free-initiative/AnswerWriting";
import CurrentAffairsQuiz from "./pages/free-initiative/CurrentAffairsQuiz";
import PracticePyq from "./pages/free-initiative/PracticePyq";
import MixContent from "./pages/free-initiative/MixContent";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";
import { AuthProvider, useAuth } from "./utils/AuthContext";

// ✅ SessionChecker Component inside Router context
const SessionChecker = ({ children }) => {
    const navigate = useNavigate();
    const { logout } = useAuth();

    useEffect(() => {
        const sessionData = sessionStorage.getItem("studentSession");

        if (sessionData) {
            const user = JSON.parse(sessionData);

            const inactiveStatus =
                user.status === 0 ||
                user.status === false ||
                user.status === "0" ||
                (typeof user.status === "string" &&
                    user.status.toLowerCase() === "inactive");

            if (inactiveStatus) {
                logout();
                toast.error("Your session is inactive. Please login again.");
                navigate("/login");
            }
        }
    }, [logout, navigate]);

    return children;
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <SessionChecker>
                    <ScrollToTop />
                    <Navbar />
                    <Routes>
                        {/* Auth routes */}
                        <Route path="/register" element={<Register />} />
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/change-password"
                            element={<ChangePasswordModal />}
                        />
                        <Route path="/phone-login" element={<PhoneLogin />} />

                        {/* Protected Routes with PrivateRoute */}
                        <Route element={<PrivateRoute />}>
                            <Route
                                path="/objective-test-instruction/:id"
                                element={<ObjectiveTestInstruction />}
                            />
                            <Route
                                path="/subjective-test-instruction/:id"
                                element={<SubjectiveTestInstruction />}
                            />
                            <Route
                                path="/fullmock-test-instruction/:id"
                                element={<FullMockTestInstruction />}
                            />
                            <Route
                                path="/objective-test-panel/"
                                element={<ObjectiveTestPanel />}
                            />
                            <Route
                                path="/subjective-test-panel/"
                                element={<SubjectiveTestPanel />}
                            />
                            <Route
                                path="/fullmock-test-panel/"
                                element={<FullMockTestPanel />}
                            />
                            <Route
                                path="/objective-test-report/"
                                element={<ObjectiveTestReport />}
                            />
                            <Route
                                path="/subjective-test-report/"
                                element={<SubjectiveTestReport />}
                            />
                            <Route
                                path="/fullmock-test-report/"
                                element={<FullMockTestReport />}
                            />
                            <Route
                                path="/test-instruction/:type/:id"
                                element={<TestInstruction />}
                            />
                            <Route
                                path="/test-panel/:type/:id"
                                element={<TestPanel />}
                            />
                            <Route
                                path="/dashboard"
                                element={<DashboardLayout />}
                            >
                                <Route path="profile" element={<Profile />} />
                                <Route
                                    path="mocks-subjective"
                                    element={<MockIndex />}
                                />
                                <Route
                                    path="live-classes"
                                    element={<div>Live Classes Page</div>}
                                />
                                <Route
                                    path="study-material"
                                    element={<StudyMaterial />}
                                />
                                <Route
                                    path="assignment"
                                    element={<div>Assignment Page</div>}
                                />
                                <Route
                                    path="payment"
                                    element={<div>Payment Page</div>}
                                />
                                <Route
                                    path="report"
                                    element={<div>Report Page</div>}
                                />
                                <Route
                                    path="answer-writing"
                                    element={<AnswerWriting />}
                                />
                                <Route
                                    path="practice-pyq"
                                    element={<PracticePyq />}
                                />
                                <Route
                                    path="current-affairs-quiz"
                                    element={<CurrentAffairsQuiz />}
                                />
                                <Route
                                    path="mix-content"
                                    element={<MixContent />}
                                />
                                <Route path="support" element={<Support />} />
                                <Route
                                    path=""
                                    element={<Navigate to="profile" />}
                                />
                            </Route>
                        </Route>

                        {/* Public User Pages */}
                        <Route path="/" element={<HomeIndex />} />
                        <Route
                            path="/upcoming-batches-details/:id"
                            element={<UpcomingBatchesDetails />}
                        />
                        <Route path="/about" element={<AboutIndex />} />
                        <Route path="/selections" element={<Selections />} />
                        <Route path="/enquire" element={<EnquirePopup />} />
                        <Route
                            path="/free-initiative"
                            element={<FreeInitiative />}
                        />
                        <Route path="/course" element={<CourseIndex />} />
                        <Route
                            path="/course-details/:id"
                            element={<CourseDetails />}
                        />
                        <Route
                            path="/course/course-page/:id"
                            element={<CoursePage />}
                        />
                        <Route
                            path="/course-details"
                            element={<CourseOverviewIndex />}
                        />
                        <Route path="/faculty" element={<FacultyIndex />} />
                        <Route path="/result" element={<ResultIndex />} />
                        <Route
                            path="/current-affairs"
                            element={<CurrentAffairsIndex />}
                        />
                        <Route
                            path="/current-affairs-details/:id"
                            element={<CurrentAffairDetails />}
                        />
                        <Route path="/topper" element={<TopperIndex />} />
                        <Route
                            path="/downloads"
                            element={<DownloadSection />}
                        />
                        <Route
                            path="/test-series"
                            element={<TestSeriesIndex />}
                        />
                        <Route path="/blogs" element={<BlogsIndex />} />
                        <Route path="/blog-details" element={<BlogDetails />} />
                        <Route
                            path="/blog-details-component/:id"
                            element={<BlogDetailsComponent />}
                        />
                        <Route path="/contact" element={<ContactIndex />} />
                        <Route
                            path="/privacy-policy"
                            element={<PrivacyPolicy />}
                        />
                        <Route
                            path="/terms-condition"
                            element={<TermCondition />}
                        />
                        <Route
                            path="/refund-policy"
                            element={<RefundPolicy />}
                        />
                        <Route
                            path="/recent-vacancies/:type"
                            element={<RecentVacancies />}
                        />
                        <Route
                            path="/recent-vacancies-details/:id"
                            element={<RecentVacancyDetails />}
                        />
                        <Route path="*" element={<NoFound />} />
                    </Routes>
                    <Footer />
                    <ToastContainer
                        position="top-right"
                        autoClose={3000}
                        newestOnTop
                        theme="light"
                    />
                </SessionChecker>
            </Router>
        </AuthProvider>
    );
}

export default App;
